/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MultipickConfigurationEnum = 'None' | 'Inline Centered' | 'Inline edge aligned';

export const MultipickConfigurationEnum = {
    NONE: 'None' as MultipickConfigurationEnum,
    INLINE_CENTERED: 'Inline Centered' as MultipickConfigurationEnum,
    INLINE_EDGE_ALIGNED: 'Inline edge aligned' as MultipickConfigurationEnum
};

